<template>
  <div class="main-content follow-static">
    <div class="subtitle margin-top-16">
      线索统计
    </div>
    <!-- 趋势-日期选择 -->
    <div>
      <date-select
        ref="followTendencyRef"
        :content-title="followTendencyTitle"
        :date-data="followTendencyDateData"
        :select-status="selectStatus"
        :default-select-index="defaultFollowTendencyIndex"
        @callbackEvent="handleCallbackTendencyEvent"
        @level-change="handleLevelChange"
        @dateTimeChange="handleDateChangeFollowTendency"
      />
      <!-- 趋势-类型选择 -->
      <div class="margin-bottom-40">
        <!-- <div class="tendency-item-change">
          <span
            v-for="(item, index) in followOverviewDatas"
            :key="index"
            class="defaule-item"
            :class="{activeItem:tendencyIndex===index}"
            @click="handleTendencyChange(index)"
          >{{ item.name }}</span>
        </div> -->
        <!-- 折线图 -->
        <HChart
          :id="tendencyId"
          ref="tendencyRef"
          :option="tendencyOption"
        />
      </div>
    </div>
    <!-- 数据 -->
    <!-- 人员分布 日期选择-->
    <div>
      <date-select
        ref="followTendencyRef"
        :content-title="followTendencyTitle"
        :date-data="followTendencyDateData"
        :select-status="selectStatus"
        :default-select-index="defaultFollowTendencyIndex"
        @callbackEvent="handleCallbackTendencyEvent"
        @level-change="handleLevelChange"
        @dateTimeChange="handleDateChangeFollowTendency"
      />
      <!-- 人员分布-类型选择 -->
      <div class="margin-bottom-40">
        <!-- <div class="tendency-item-change">
          <span
            v-for="(item, index) in followOverviewDatas"
            :key="index"
            class="defaule-item"
            :class="{activeItem:tendencyIndex===index}"
            @click="handleTendencyChange(index)"
          >{{ item.name }}</span>
        </div> -->
        <!-- 柱形图 -->
        <HChart
          id="disclue"
          ref="disclueRef"
          :option="disClueOption"
        />
      </div>
    </div>
    <!-- 数据 -->
    <div>
      <!-- 日期选择 -->
      <date-select
        ref="followTableDataRef"
        :content-title="dataTitle"
        :date-data="dataDateData"
        :default-select-index="defaultFollowDataIndex"
        @callbackEvent="handleCallbackDataEvent"
        @dateTimeChange="handleDateChangeFollowTableData"
      />
      <!-- 表格 -->
      <table-data
        class="margin-top-24  margin-bottom-40"
        :table-data="tableData"
        :columns="tableColumns"
        :time="detailTimeData"
        :pagination="isShowPagination"
        type="follow"
        @changeParams="handleChangeParams"
      />
    </div>
    <a-spin
      v-if="loadingContent"
      class="spin-css"
    />
  </div>
</template>
<script>
import DateSelect from './components/DateSelectComponent.vue'
import TableData from './components/TableData.vue'
import HChart from '@/components/pc/HighChart.vue'
import { highchartAreaOption, highchartcolumnOption } from '@/lib/chart-option'
import { overviewTendency, overviewData } from '@/lib/statistic-utils.js'
import { mapState, mapActions } from 'vuex'
import { fixed } from '@/lib/directives'
export default {
  components: {
    DateSelect,
    HChart,
    TableData
  },
  directives: { fixed },
  data () {
    return {
      isShowPagination: false,
      tendencyIndex: 0,
      tendencyDataList: [],
      tableData: [],
      tableColumns: [],
      tablecolumnsArray: [],
      dataTitle: this.$t('message["1130"]'),
      // eventData: ['录入时间在所选定时间范围内新增跟进信息数量', '当前时间范围内的跟进信息回访次数汇总', '录入时间在所选定时间范围内，并且跟进状态为成交的信息数量', '录入时间在所选定时间范围内，跟进信息中的成交金额汇总'],
      defaultFollowDataIndex: 3,
      dataDateData: overviewData,
      tendencyId: 'tendencyId',
      tendencyOption: highchartAreaOption(),
      disClueOption: highchartcolumnOption(),
      selectStatus: true,
      followTendencyTitle: this.$t('message["895"]'),
      defaultFollowTendencyIndex: 2,
      followTendencyDateData: overviewTendency,
      followContentTitle: this.$t('message["346"]'),
      defaultFollowIndex: 3,
      overviewData: overviewData,
      overviewTimeData: { timetype: 5 },
      detailTimeData: { timetype: 5 },
      tendencyTimeData: { timetype: 6 },
      levelValue: 0,
      top: 0,
      fixed: true
    }
  },
  computed: {
    ...mapState('statistic', ['tendencyFollowDatas', 'followOverviewDatas', 'followTablesDetailDatas', 'loadingContent', 'formateRangeDatasStatus']),
    viewContentChildrenWidth () {
      let count = this.followOverviewDatas.length
      return parseInt(((1040 - (count - 1) * 20) / count)) + 'px'
    },
    orderPrice () {
      return this.$t('message["111"]')
    }
  },
  watch: {
    tendencyFollowDatas (val) {
      if (!val) return
      this.tendencyDataList = this.formateTendencyData(val[this.tendencyIndex])
      this.drawLine()
      this.drawColumn()
      document.title = this.$t('message["1364"]') + `-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
    },
    followTablesDetailDatas (val) {
      if (!val) return
      if (val.count) {
        this.isShowPagination = true
      } else {
        this.isShowPagination = false
      }
      this.tableColumns = this.formateTableColmunsData(val.config)
      this.tableData = this.formateTableDatas(val.data)
      if (val.total) {
        this.tableData = this.tableData.concat(this.formateTableDatas(val.total, 'total', val.maxPage))
      }
    }
  },
  mounted () {
    this.fetchGetFollowTendencyDatas({ ...this.tendencyTimeData })
    this.fetchGetFollowDataOverview(this.overviewTimeData)
    this.fetchGetFollowDetailTableDatas({ ...this.detailTimeData, page: 1 })
    if (this.tendencyFollowDatas) {
      if (Array.isArray(this.tendencyFollowDatas)) {
        this.tendencyDataList = this.formateTendencyData(this.tendencyFollowDatas[0])
        this.drawLine()
        this.drawLine()
        this.drawColumn()
      }
    }
  },
  methods: {
    ...mapActions('statistic', ['fetchGetFollowTendencyDatas', 'fetchGetFollowDataOverview', 'fetchGetFollowDetailTableDatas']),

    /* 趋势-折线图-初始化数据 */
    drawLine () {
      let name = this.$t('message["1353"]')
      if (this.followOverviewDatas && this.followOverviewDatas[this.tendencyIndex]) {
        name = this.followOverviewDatas[this.tendencyIndex].name
      }
      this.$refs.tendencyRef.chartObj.update({
        series: [
          {
            name,
            data: [4, 8, 9, 12, 30, 60, 80],
            color: '#5077AA'
          },
          {
            name: 'weee',
            data: [2, 6, 10, 30, 40, 50, 70],
            color: '#FF0000'
          }
        ]
      })
      this.$refs.tendencyRef.chartObj.yAxis.labels = {
        step: 2
      }
      let isNull = this.tendencyDataList.data.every(item => item === 0)
      this.$refs.tendencyRef.chartObj.yAxis[0].setExtremes(0, isNull ? 10 : null)
      this.$refs.tendencyRef.chartObj.xAxis[0].setCategories(this.tendencyDataList.category)
    },
    /* 趋势-折线图-初始化数据 */
    drawColumn () {
      let name = this.$t('message["1353"]')
      if (this.followOverviewDatas && this.followOverviewDatas[this.tendencyIndex]) {
        name = this.followOverviewDatas[this.tendencyIndex].name
      }
      console.log(this.$refs.disclueRef.chartObj.series[0].chart)
      this.$refs.disclueRef.chartObj.update({
        series: [
          {
            name,
            data: [4, 8, 9, 12, 30, 60, 80],
            color: '#5077AA'
          },
          {
            name: 'weee',
            data: [2, 6, 10, 30, 40, 50, 70],
            color: '#FF0000'
          }
        ]
      })
      this.$refs.disclueRef.chartObj.yAxis.labels = {
        step: 2
      }
      let isNull = this.tendencyDataList.data.every(item => item === 0)
      this.$refs.disclueRef.chartObj.yAxis[0].setExtremes(0, isNull ? 10 : null)
      this.$refs.disclueRef.chartObj.xAxis[0].setCategories(this.tendencyDataList.category)
    },
    /* 表格-操作 */
    handleChangeParams (value) {
      if (!value) return
      const { roleid } = this.detailTimeData
      if (roleid === '0') {
        delete value.roleid
        delete value.userid
        delete value.groupid
      }
      this.detailTimeData = Object.assign(this.detailTimeData, value)
    },
    /* 处理趋势数据 */
    formateTendencyData (array) {
      const valueJson = {
        category: [],
        data: []
      }
      if (Array.isArray(array)) {
        array.map(value => {
          valueJson.category.push(value.name)
          valueJson.data.push(Number(value.num))
        })
      }
      return valueJson
    },
    /* 处理表格-header数据 */
    formateTableColmunsData (array) {
      let tempArray = []
      this.tablecolumnsArray = []
      if (Array.isArray(array)) {
        array.map(value => {
          this.tablecolumnsArray.push(value.sortId)
          if (value.options) {
            this.tableConfigOptions = Object.values(value.options)
          }
          if (value.sortable) {
            if (value.sortId === 'rank') {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                scopedSlots: { customRender: 'rank' },
                sorter: (a, b) => a[value.sortId] - b[value.sortId]
              })
            } else if (value.sortId === 'name') {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                scopedSlots: { customRender: 'name', filterDropdown: 'filterDropdownName' },
                options: this.formateFilter(value.options),
                // filterMultiple: false,
                sorter: (a, b) => a[value.sortId] - b[value.sortId],
                width: 200,
                filterIcon: <em class="th-filter-icon anticon anticon-filter"><i class="iconfont iconicon-test19"></i></em>
              })
            } else {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                sorter: (a, b) => a[value.sortId] - b[value.sortId]
              })
            }
          } else {
            if (value.sortId === 'rank') {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                scopedSlots: { customRender: 'rank' }
              })
            } else if (value.sortId === 'name') {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId,
                options: this.formateFilter(value.options),
                // filterMultiple: false,
                scopedSlots: { customRender: 'name', filterDropdown: 'filterDropdownName' },
                width: 150,
                filterIcon: <em class="th-filter-icon anticon anticon-filter"><i class="iconfont iconicon-test19"></i></em>
              })
            } else {
              tempArray.push({
                title: value.name,
                key: value.sortId,
                dataIndex: value.sortId
              })
            }
          }
        })
      }
      return tempArray
    },
    /* 表格数据筛选 */
    formateFilter (object) {
      const keys = Object.keys(object)
      const values = Object.values(object)
      const temp = []
      if (Array.isArray(keys)) {
        keys.map((value, index) => {
          let json = {
            text: values[index][0],
            value: value
          }
          temp.push(json)
        })
      }
      return temp
    },
    /* 处理表格-body数据 */
    formateTableDatas (array, flag, maxPage) {
      let tempArray = []
      let tpadv = []
      if (Array.isArray(array)) {
        if (flag) {
          if (maxPage && maxPage <= 1) {
            tpadv = array.slice(1)
          } else {
            tpadv = array
          }
        } else {
          tpadv = array
        }
        tpadv.map((value, indexs) => {
          let json = {}
          value.map((values, index) => {
            if (flag) {
              if (index === 0) {
                if (indexs === 0) {
                  if (maxPage && maxPage > 1) {
                    json[this.tablecolumnsArray[index]] = this.$t('message["177"]')
                  } else {
                    json[this.tablecolumnsArray[index]] = this.$t('message["910"]')
                  }
                } else {
                  json[this.tablecolumnsArray[index]] = this.$t('message["910"]')
                }
                json[this.tablecolumnsArray[index + 1]] = values
              } else {
                json[this.tablecolumnsArray[index + 1]] = values
              }
            } else {
              json[this.tablecolumnsArray[index]] = values
            }
          })
          tempArray.push(json)
        })
      }
      return tempArray
    },
    /* 范围-选择 */
    handleRangeFollow (value, b) {
      delete this.overviewTimeData.roleid
      delete this.overviewTimeData.groupid
      delete this.overviewTimeData.userid
      delete this.overviewTimeData.ismerge
      delete this.tendencyTimeData.roleid
      delete this.tendencyTimeData.groupid
      delete this.tendencyTimeData.userid
      delete this.tendencyTimeData.ismerge
      delete this.detailTimeData.roleid
      delete this.detailTimeData.groupid
      delete this.detailTimeData.userid
      delete this.detailTimeData.ismerge
      if (value.length > 0) {
        // if (value[0] !== 'roleid-0') {
        value.map(item => {
          const array = item.split('-')
          const [name, key] = array
          this.overviewTimeData[name] = key
          this.tendencyTimeData[name] = key
          this.detailTimeData[name] = key
          if (b) {
            this.overviewTimeData['ismerge'] = 1
            this.tendencyTimeData['ismerge'] = 1
            this.detailTimeData['ismerge'] = 1
          }
        })
        // }
      }
      this.fetchGetFollowDataOverview(this.overviewTimeData)
      this.fetchGetFollowTendencyDatas({ ...this.tendencyTimeData })
      this.fetchGetFollowDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    /* 概览-日期选择 */
    handleDateChangeFollow (value) {
      this.$refs.followOverViewRef.initdDteSelectIndex()
      this.overviewTimeData.starttime = value[0]
      this.overviewTimeData.endtime = value[1]
      delete this.overviewTimeData.timetype
      this.fetchGetFollowDataOverview(this.overviewTimeData)
    },
    /* 趋势-日期选择 */
    handleDateChangeFollowTendency (value) {
      this.$refs.followTendencyRef.initdDteSelectIndex()
      this.tendencyTimeData.starttime = value[0]
      this.tendencyTimeData.endtime = value[1]
      delete this.tendencyTimeData.timetype
      // this.fetchGetFollowTendencyDatas({ ...this.tendencyTimeData, level: this.levelValue })
      this.fetchGetFollowTendencyDatas({ ...this.tendencyTimeData })
    },
    /* 数据-日期选择 */
    handleDateChangeFollowTableData (value) {
      this.$refs.followTableDataRef.initdDteSelectIndex()
      this.detailTimeData.starttime = value[0]
      this.detailTimeData.endtime = value[1]
      delete this.detailTimeData.timetype
      this.fetchGetFollowDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    /* 概览-近7天 */
    handleCallbackEvent (val) {
      delete this.overviewTimeData.starttime
      delete this.overviewTimeData.endtime
      this.overviewTimeData.timetype = val.key
      this.fetchGetFollowDataOverview(this.overviewTimeData)
    },
    /* 趋势-近7天 */
    handleCallbackTendencyEvent (val) {
      delete this.tendencyTimeData.starttime
      delete this.tendencyTimeData.endtime
      this.tendencyTimeData.timetype = val.key
      this.fetchGetFollowTendencyDatas({ ...this.tendencyTimeData })
    },
    /* 数据-近7天 */
    handleCallbackDataEvent (val) {
      delete this.detailTimeData.starttime
      delete this.detailTimeData.endtime
      this.detailTimeData.timetype = val.key
      this.fetchGetFollowDetailTableDatas({ ...this.detailTimeData, 'page': 1 })
    },
    /* 趋势-类型选择 */
    handleTendencyChange (index) {
      this.tendencyIndex = index
      this.tendencyDataList = this.formateTendencyData(this.tendencyFollowDatas[index])
      this.drawLine()
    },
    /* 趋势-选择等级 */
    handleLevelChange (val) {
      if (val === '-1') {
        delete this.tendencyTimeData.level
      } else {
        this.tendencyTimeData.level = val
      }

      this.fetchGetFollowTendencyDatas({ ...this.tendencyTimeData })
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/statistic/style.scss';
.tendency-item-change {
  width: 100%;
  text-align: center;
  margin-bottom: 24px;
  margin-top: 24px;
  .defaule-item {
    width: 80px;
    height: 32px;
    padding: 4px 12px 4px 12px;
    background-color: #ffffff;
    border-top: solid 1px #d6d6d6;
    border-bottom: solid 1px #d6d6d6;
    font-size: 14px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    letter-spacing: normal;
    color: #333333;
    cursor: pointer;
    &:first-child {
      border: solid 1px #d6d6d6;
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
    }
    &:last-child {
      border: solid 1px #d6d6d6;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
  }
}
.activeItem {
  border: solid 1px #5077aa !important;
  color: #5077aa !important;
}
.spin-css {
  position: absolute;
  top: 50%;
  left: 50%;
}
.follow-static ::v-deep {
  .ant-table-thead > tr > th.ant-table-column-has-actions.ant-table-column-has-sorters {
    padding: 0;
  }

}
</style>
<style lang="scss">
.followOverView-tooltip {
  min-width: 200px;
  max-width: 400px;
  .ant-tooltip-inner {
    color: $gray3;
    min-width: 200px;
    max-width: 260px;
  }
  .ant-tooltip-content:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    left: 50%;
    margin-left: -7px;
    border-width: 7px 7px 0px 7px;
    border-color: transparent;
    border-top-color: #ebebeb;
    border-style: solid;
  }
  &.ant-tooltip-placement-top {
    .ant-tooltip-arrow {
      bottom: -4px !important;
      z-index: 2;
      border-top-color: #fff !important;
    }
  }
}
</style>
